/**
 * Theme System Type Definitions
 *
 * These constants define the structure of theme configurations used throughout
 * the application.
 *
 * V2 Update: Added support for shadows, gradients, radii, and glass morphism
 */

/**
 * CSS variable names for theming (V1 Core)
 */
export const CSS_VARIABLE_NAMES = [
  // V1 Core Colors
  '--header-color',
  '--header-hover',
  '--frame-color',
  '--button-color',
  '--button-hover',
  '--primary-action-bg',       // Primary action button background (for contrast)
  '--primary-action-bg-hover', // Primary action button hover
  '--highlight-button-color',
  '--highlight-button-hover',
  '--header-button-color',
  '--text-color',
  '--light-text-color',
  '--button-text-color',
  '--header-text-color',
  '--header-button-text-color',
  '--alert-color',
  '--alert-hover',
  '--success-color',
  '--success-hover',
  '--inactive-color',

  // V2 Shadows
  '--shadow-soft',
  '--shadow-soft-sm',
  '--shadow-soft-lg',
  '--shadow-soft-xl',
  '--shadow-glow-primary',
  '--shadow-glow-primary-lg',
  '--shadow-glow-accent',
  '--shadow-glow-accent-lg',
  '--shadow-glow-success',

  // V2 Gradients
  '--gradient-primary',
  '--gradient-accent',
  '--gradient-success',
  '--gradient-surface',

  // V2 Glass Morphism
  '--glass-bg',
  '--glass-border',
  '--glass-bg-dark',

  // V2 Border Radii
  '--radius-sm',
  '--radius-md',
  '--radius-lg',
  '--radius-xl',
  '--radius-2xl',
  '--radius-full',

  // V2 Transitions
  '--transition-fast',
  '--transition-normal',
  '--transition-slow',
  '--transition-bounce'
]

/**
 * Mapping from ThemeColors keys to CSS variable names
 */
export const COLOR_TO_CSS_VAR = {
  // V1 Core Colors
  headerColor: '--header-color',
  headerHover: '--header-hover',
  frameColor: '--frame-color',
  buttonColor: '--button-color',
  buttonHover: '--button-hover',
  primaryActionBg: '--primary-action-bg',           // Primary action button background
  primaryActionBgHover: '--primary-action-bg-hover', // Primary action button hover
  highlightButtonColor: '--highlight-button-color',
  highlightButtonHover: '--highlight-button-hover',
  headerButtonColor: '--header-button-color',
  textColor: '--text-color',
  lightTextColor: '--light-text-color',
  buttonTextColor: '--button-text-color',
  headerTextColor: '--header-text-color',
  headerButtonTextColor: '--header-button-text-color',
  alertColor: '--alert-color',
  alertHover: '--alert-hover',
  successColor: '--success-color',
  successHover: '--success-hover',
  inactiveColor: '--inactive-color',

  // V2 Glass Morphism Colors
  glassBackground: '--glass-bg',
  glassBorder: '--glass-border',
  glassBackgroundDark: '--glass-bg-dark'
}

/**
 * V2: Mapping from shadow keys to CSS variable names
 */
export const SHADOW_TO_CSS_VAR = {
  soft: '--shadow-soft',
  softSm: '--shadow-soft-sm',
  softLg: '--shadow-soft-lg',
  softXl: '--shadow-soft-xl',
  glowPrimary: '--shadow-glow-primary',
  glowPrimaryLg: '--shadow-glow-primary-lg',
  glowAccent: '--shadow-glow-accent',
  glowAccentLg: '--shadow-glow-accent-lg',
  glowSuccess: '--shadow-glow-success'
}

/**
 * V2: Mapping from radius keys to CSS variable names
 */
export const RADIUS_TO_CSS_VAR = {
  sm: '--radius-sm',
  md: '--radius-md',
  lg: '--radius-lg',
  xl: '--radius-xl',
  '2xl': '--radius-2xl',
  full: '--radius-full'
}

/**
 * V2: Mapping from transition keys to CSS variable names
 */
export const TRANSITION_TO_CSS_VAR = {
  fast: '--transition-fast',
  normal: '--transition-normal',
  slow: '--transition-slow',
  bounce: '--transition-bounce'
}
